const COLUMNS_GROUPS = [
  {
    id: "date",
    label: "DATE",
    widget: "text",
    width: 150
  },
  {
    id: "estimatenumber",
    label: "ESTIMATE NUMBER",
    widget: "text",
    width: 200
  },
  {
    id: "referencenumber",
    label: "REFERENCE NUMBER",
    widget: "text",
    width: 200
  },
  {
    id: "customername",
    label: "CUSTOMER NAME",
    widget: "text",
    width: 250
  },
  {
    id: "status",
    label: "STATUS",
    widget: "text",
    width: 150
  },
  {
    id: "amount",
    label: "AMOUNT",
    widget: "number",
    width: 150
  }
];

const ROW_DATA = [
  {
    date: "10/12/2025",
    estimatenumber: "EST-10234",
    referencenumber: "REF-55221",
    customername: "Arvind Textiles",
    status: "Sent",
    amount: 150000
  },
  {
    date: "08/12/2025",
    estimatenumber: "EST-10212",
    referencenumber: "REF-55110",
    customername: "Sri Lakshmi Traders",
    status: "Accepted",
    amount: 98750
  },
  {
    date: "05/12/2025",
    estimatenumber: "EST-10198",
    referencenumber: "REF-55009",
    customername: "Kavin Exports",
    status: "Declined",
    amount: 45000
  }];


export {COLUMNS_GROUPS, ROW_DATA};
